import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import _ from "lodash";
import { CommonLayout } from '../common/CommonLayout';
import { setInitStorage } from '../common/InitLocalStore';
import { sortingData } from '../common/Util';
import { ErrorModal } from '../common/ErrorModal';
import { ActionLoadingModal } from '../common/ActionLoadingModal';
import AddWebsiteManagementItemModal from './AddWebsiteManagementItemModal';
import UpdateWebsiteManagementItemModal from './UpdateWebsiteManagementItemModal';
import GlobalSettingsResponseModal from '../common/GlobalSettingsResponseModal';
import { getTenantList, getWebsiteManagementList, clearWebsiteManagementTable, clearTenantErrorResponseMessage, clearWebsiteManagementErrorResponseMessage, sendWebsiteManagementItem, updateWebsiteManagementItem, sendRequestWebsiteManagementDelete, clearNextPossibleResponseMessage } from '../../services/apiOperations';
import TableGrid from '../common/TableGrid';
import MultiSelectTextbox from '../common/MultiSelectTextbox';
import ConfirmationModal from '../common/ConfirmationModal';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/tableGrid.scss';
import ReactTooltip from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';

if (process.env.REACT_APP_HOST_ENV === "production") {
    console.log = function () { }
}

const CONSTANT_TYPE = {
    selectedTenant: "selectedTenant",
    categoryName:"categoryName"
}

const WEBSITE_CATEGORY_OPTIONS = [
    {
        "value": "Uncategorized",
        "label": "Uncategorized"
    },
    {
        "value": "Adult/Sexually Explicit",
        "label": "Adult/Sexually Explicit"
    },
    {
        "value": "Advertisements & Pop-Ups",
        "label": "Advertisements & Pop-Ups"
    },
    {
        "value": "Alcohol & Tobacco",
        "label": "Alcohol & Tobacco"
    },
    {
        "value": "Arts",
        "label": "Arts"
    },
    {
        "value": "Blogs & Forums",
        "label": "Blogs & Forums"
    },
    {
        "value": "Business",
        "label": "Business"
    },
    {
        "value": "Chat",
        "label": "Chat"
    },
    {
        "value": "Computing & Internet",
        "label": "Computing & Internet"
    },
    {
        "value": "Criminal Activity",
        "label": "Criminal Activity"
    },
    {
        "value": "Downloads",
        "label": "Downloads"
    },
    {
        "value": "Education",
        "label": "Education"
    },
    {
        "value": "Entertainment",
        "label": "Entertainment"
    },
    {
        "value": "Fashion & Beauty",
        "label": "Fashion & Beauty"
    },
    {
        "value": "Finance & Investment",
        "label": "Finance & Investment"
    },
    {
        "value": "Food & Dining",
        "label": "Food & Dining"
    },
    {
        "value": "Gambling",
        "label": "Gambling"
    },
    {
        "value": "Games",
        "label": "Games"
    },
    {
        "value": "Government",
        "label": "Government"
    },
    {
        "value": "Hacking",
        "label": "Hacking"
    },
    {
        "value": "Health & Medicine",
        "label": "Health & Medicine"
    },
    {
        "value": "Hobbies & Recreation",
        "label": "Hobbies & Recreation"
    },
    {
        "value": "Hosting Sites",
        "label": "Hosting Sites"
    },
    {
        "value": "Illegal Drugs",
        "label": "Illegal Drugs"
    },
    {
        "value": "Infrastructure",
        "label": "Infrastructure"
    },
    {
        "value": "Intimate Apparel & Swimwear",
        "label": "Intimate Apparel & Swimwear"
    },
    {
        "value": "Intolerance & Hate",
        "label": "Intolerance & Hate"
    },
    {
        "value": "Job Search & Career Development",
        "label": "Job Search & Career Development"
    },
    {
        "value": "Kid's Sites",
        "label": "Kid's Sites"
    },
    {
        "value": "Motor Vehicles",
        "label": "Motor Vehicles"
    },
    {
        "value": "News",
        "label": "News"
    },
    {
        "value": "Peer-to-Peer",
        "label": "Peer-to-Peer"
    },
    {
        "value": "Personals and Dating",
        "label": "Personals and Dating"
    },
    {
        "value": "Philanthropic & Professional Orgs.",
        "label": "Philanthropic & Professional Orgs."
    },
    {
        "value": "Phishing & Fraud",
        "label": "Phishing & Fraud"
    },
    {
        "value": "Photo Searches",
        "label": "Photo Searches"
    },
    {
        "value": "Politics",
        "label": "Politics"
    },
    {
        "value": "Proxies & Translators",
        "label": "Proxies & Translators"
    },
    {
        "value": "Real Estate",
        "label": "Real Estate"
    },
    {
        "value": "Reference",
        "label": "Reference"
    },
    {
        "value": "Religion",
        "label": "Religion"
    },
    {
        "value": "Ringtones/Mobile Phone Downloads",
        "label": "Ringtones/Mobile Phone Downloads"
    },
    {
        "value": "Search Engines",
        "label": "Search Engines"
    },
    {
        "value": "Sex Education",
        "label": "Sex Education"
    },
    {
        "value": "Shopping",
        "label": "Shopping"
    },
    {
        "value": "Society & Culture",
        "label": "Society & Culture"
    },
    {
        "value": "Spam URLs",
        "label": "Spam URLs"
    },
    {
        "value": "Sports",
        "label": "Sports"
    },
    {
        "value": "Spyware",
        "label": "Spyware"
    },
    {
        "value": "Streaming Media",
        "label": "Streaming Media"
    },
    {
        "value": "Tasteless & Offensive",
        "label": "Tasteless & Offensive"
    },
    {
        "value": "Travel",
        "label": "Travel"
    },
    {
        "value": "Violence",
        "label": "Violence"
    },
    {
        "value": "Weapons",
        "label": "Weapons"
    },
    {
        "value": "Web-based E-mail",
        "label": "Web-based E-mail"
    },
    {
        "value": "Custom",
        "label": "Custom"
    },
    {
        "value": "Anonymizing Proxies",
        "label": "Anonymizing Proxies"
    },
    {
        "value": "Translation Services",
        "label": "Translation Services"
    }
]

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getWebsiteManagementList: (referrer, queryFilterString, force) => dispatch(getWebsiteManagementList(referrer, queryFilterString, force)),
    clearNextPossibleResponseMessage:()=>dispatch(clearNextPossibleResponseMessage()),
    getTenantList: (referrer, queryFilterString) => dispatch(getTenantList(referrer, queryFilterString)),
    clearWebsiteManagementTable: () => dispatch(clearWebsiteManagementTable()),
    clearWebsiteManagementErrorResponseMessage: () => dispatch(clearWebsiteManagementErrorResponseMessage()),
    clearTenantErrorResponseMessage: () => dispatch(clearTenantErrorResponseMessage()),
})

const NULL_UNDEFINED_EMPTY_CHECK = [null, undefined, ""]
class WebsiteManagementItems extends React.Component {
    constructor(props) {
        super(props);
        this.addWebsiteManagementModalRef = React.createRef();
        this.updateWebsiteManagementModalRef = React.createRef();
        setInitStorage(props.referrerHostname, queryString.parse(props.location.search))
        this.state = {
            queryParams: queryString.parse(props.location.search),
            kaseyaParams: queryString.parse(props.location.search),
            tenantList: [],
            filtered: [],
            rowData: [],
            stopInterval: false,
            updateInterval: false,
            clearFilterBool: false,
            clearSearchBox: false,
            selectedAction: '',
            showActionWebsiteManagement: false,
            showErrorActionWebsiteManagement: false,
            actionWebsiteManagementMessage: '',
            columnDefs: [
                {
                    text: "Tenant Name", dataField: "tenant.name", sort: true, onSort: this.onSortChange, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "URL", dataField: 'url', sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Tags", dataField: "tags", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Category Override", dataField: "categoryName", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                },
                {
                    text: "Comment", dataField: "comment", sort: true, onSort: this.onSortChange, width: 200, formatter: (cell) => {
                        if (!NULL_UNDEFINED_EMPTY_CHECK.includes(cell))
                            return cell
                        else
                            return "-"
                    }
                }
            ],
            defaultSorted: [{
                dataField: 'tenant.name',
                order: 'desc'
            }],
            currentPage: 1,
            pageWiseSelectedRows: [],
            loadingAction: false,
            sortChangeBool: false,
            successCount: 0,
            failCount: 0,
            clearSelection: false,
            selectedWebsiteManagementBody: [],
            showDeleteConfirmationModal: false,
            DeleteConfirmationModalMessage: '',
            showAddWebsiteManagementItemModal: false,
            showGlobalSettingsResponseModal: false,
            messageGlobalSettingsResponseModal: '',
            machineName: "",
        }
        this.componentWillMountFunction()
    }

    componentWillMountFunction = () => {
        let queryFitlerString = queryString.parse(this.props.location.search)
        if (queryFitlerString !== "") {
            if (this.props.location.filtersObject) {
                let filters = this.state.filtered
                if (this.props.location.state) {
                    let newPropsSelectedTenantId = { value: this.props.location.state.id, type: CONSTANT_TYPE.selectedTenant }
                    filters.push(newPropsSelectedTenantId)
                }
                this.setState({
                    filtered: filters
                })
            }
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search);
        }
        else {
            this.props.getTenantList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.website_management.force_limit_reached || this.props.website_management.queued_job_exist || this.props.website_management.scheduled){
            this.showToast();
            this.props.website_management.queued_job_exist = null
            this.props.website_management.force_limit_reached = null
            this.props.website_management.scheduled = null
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.website_management.website_management_list) !== JSON.stringify(prevState.rowData)) {
            this.setState({
                rowData: this.props.website_management.website_management_list
            })
            this.clearErrorResponseToast()
        }
        if (JSON.stringify(this.props.website_management.error_response_message) !== JSON.stringify(prevProps.website_management.error_response_message)) {
            this.setState({
                websiteManagementErrorResponse: this.props.website_management.error_response_message
            })
        }
        if (JSON.stringify(this.props.tenants.tenant_list) !== JSON.stringify(prevProps.tenants.tenant_list)) {
            let createTenantListPair = []
            this.props.tenants.tenant_list.forEach((element) => {
                createTenantListPair.push({ value: element.id, label: element.showAs })
            })
            this.setState({
                tenantList: createTenantListPair
            })
            if (this.props.location.state === undefined) {
                this.getWebsiteManagementData(false, false)
            }
        }
        if (
            this.props.settings.SophosIdTypeIsTenant &&
            JSON.stringify(this.props.settings.SophosIdTypeIsTenant) !==
            JSON.stringify(prevProps.settings.SophosIdTypeIsTenant)
        ) {
            this.getWebsiteManagementData();
            const columDefs = [...this.state.columnDefs];
            const withoutTenantColumnDefs = _.remove(
                columDefs,
                (cols) => cols.dataField !== "tenant.name"
            );
            this.setState({ columnDefs: withoutTenantColumnDefs });
        }
    }

    componentWillUnmount() {
        this.clearErrorResponseToast()
        this.clearTenantErrorResponseToast()
    }

    onSortChange = () => {
        this.setState({
            sortChangeBool: !this.state.sortChangeBool
        })
    }

    clearNextpossibleToast=()=>{
        this.props.clearNextPossibleResponseMessage()
    }

    showToast=()=>{
        if(this.props.website_management.force_limit_reached){
            let last_sync_time=new Date(this.props.website_management.last_force_update_time*1000)
            let req_per_hour_diff=Math.round(60/this.props.website_management.req_per_hour)
            let next_response_time=new Date((this.props.website_management.last_force_update_time*1000)+(1000*60*req_per_hour_diff))
            toast.error(`Last sync ran at ${last_sync_time.toLocaleTimeString()}. Next available sync at ${next_response_time.toLocaleTimeString()}`,{containerId: 'A', onClose: () => this.clearNextpossibleToast()});
        }
        else if(this.props.website_management.queued_job_exist)
        {
            toast.error("Job already exist in queue",{containerId: 'A', onClose: () => this.clearNextpossibleToast()});
        }
        else if(this.props.website_management.scheduled)
        {
            toast.success("Force sync job scheduled successfuly",{containerId: 'A', onClose: () => this.clearNextpossibleToast()});
        }
    }

    filterData = (data) => {
        let result = []
        let appliedFilterLength = this.state.filtered.length;
        if (appliedFilterLength > 0) {
            for (let i = 0; i < data.length; i++) {
                let matchedCount = 0
                for (let j = 0; j < appliedFilterLength; j++) {
                    if (this.state.filtered[j].type === CONSTANT_TYPE.selectedTenant && data[i]["tenant"] && data[i]["tenant"]["id"].includes(this.state.filtered[j].value)) {
                        matchedCount++;
                    }
                    if (this.state.filtered[j].type === CONSTANT_TYPE.categoryName && (this.state.filtered[j].value.toLowerCase() === "all" || data[i]["categoryName"].toLowerCase() === this.state.filtered[j].value.toLowerCase())) {
                        matchedCount++;
                    }
                }
                if (matchedCount === appliedFilterLength) {
                    result.push(data[i])
                }
            }
        } else {
            result = [...data]
        }
        return result
    }

    getPageWiseSelectedRowsFromTable = (currentPage, selectedRowData) => {
        let selectedWebsiteManagementBody = []
        selectedRowData.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedWebsiteManagementBody.push({
                    "id": eachRow.id,
                    "tenantId": eachRow.tenant.id,
                    "tenantName": eachRow.tenant.name,
                    "url": eachRow.url,
                    "comment": eachRow.comment,
                    "tags": eachRow.tags,
                    "categoryId": eachRow.categoryId,
                    "categoryName": eachRow.categoryName
                })
            })
        })
        this.setState({
            currentPage: currentPage,
            pageWiseSelectedRows: selectedRowData,
            selectedWebsiteManagementBody: selectedWebsiteManagementBody
        })
    }

    setTablePage = (page) => {
        this.setState({
            currentPage: page,
        })
    }

    findFilterValueByType(arrayValue, searchType) {
        return arrayValue.type === searchType
    }

    selectFilters = (value, type, intervalInit = false) => {
        let filters = this.state.filtered
        let newfilterObj = { value: value, type: type }
        const obj = filters.find((arrayValue) => this.findFilterValueByType(arrayValue, newfilterObj.type))
        if (obj !== undefined) {
            const index = filters.indexOf(obj)
            filters.splice(index, 1)
        }
        if (value !== '')
            filters.push(newfilterObj)
        this.setState({
            filtered: filters,
            clearSearchBox: !this.state.clearSearchBox
        })
    }

    clearFilter() {
        let filters = []
        this.setState({ filtered: filters, clearFilterBool: !this.state.clearFilterBool, updateInterval: !this.state.updateInterval, stopInterval: false, selectedAction: "" })
    }

    getWebsiteManagementData(fromOtherFilter = false, intervalInit = false, force=false) {
        if (this.props.location.search !== "") {
            if(!force)
            {
                this.props.clearWebsiteManagementTable()
            }
            const queryParams = queryString.parse(this.props.location.search)
            if(force){
                let filters = this.state.filtered;
                let filteredObject=filters.find((arrayValue)=>this.findFilterValueByType(arrayValue,CONSTANT_TYPE.selectedTenant));
                if(filteredObject){
                    queryParams.sophosTenantId=filteredObject.value
                }
            }
            const queryFilter = queryString.stringify(queryParams)
            this.props.getWebsiteManagementList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), "?" + queryFilter, force)
        }
        else {
            this.props.getWebsiteManagementList(this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), force)
        }
    }

    getWebsiteManagementSelectedId = (selectedId) => {
        this.setState({
            singleSelectedWebsiteManagementId: selectedId
        })
    }

    tablegridMessage() {
        if (!this.props.website_management.is_loading) {
            let filteredObject = this.state.filtered.find((arrayValue) => this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant))
            if (filteredObject !== undefined) {
                let checkTenantDetails = this.props.tenants.tenant_list.find((tenantValue) => tenantValue.id === filteredObject.value)
                if (checkTenantDetails) {
                    if (checkTenantDetails.apiHost === null || checkTenantDetails.apiHost === "" || checkTenantDetails.apiHost === "NULL" || checkTenantDetails.apiHost === "null" || checkTenantDetails.apiHost === undefined) {
                        return { message: 'This account has not been activated; <br/>Please activate from <a target="_blank" href="https://cloud.sophos.com/">Sophos Central Administration Console</a>', type: "error" }
                    }
                    else {
                        return { message: "No Website Items found to match your search.", type: "info" }
                    }
                }
                else {
                    return { message: "No Website Items found to match your search.", type: "info" }
                }

            }
            else {
                return { message: "No Website Items found to match your search.", type: "info" }
            }
        }
        else {
            return { message: "Loading....", type: "info" }
        }
    }

    clearErrorResponseToast = () => {
        this.props.clearWebsiteManagementErrorResponseMessage()
    }

    clearTenantErrorResponseToast = () => {
        this.props.clearTenantErrorResponseMessage()
    }

    getNonSelectableRows = (allRows) => {
        let allNonselectableRowIds = []
        if (this.state.selectedAction !== "") {
            allRows.forEach((element) => {
                if (element.websiteManagementAction) {
                    allNonselectableRowIds.push(element.id)
                }
            })
        }
        else {
            allNonselectableRowIds = []
        }
        return allNonselectableRowIds
    }

    closeActionWebsiteManagement = () => {
        if (this.state.pageWiseSelectedRows.length === 0 || this.state.pageWiseSelectedRows[0].selectedRow.length === 0) {
            this.setState({
                showErrorActionWebsiteManagement: false,
                showActionWebsiteManagement: false,
                actionWebsiteManagementMessage: ""
            })
        }
        else {
            this.setState({
                showActionWebsiteManagement: false,
                showErrorActionWebsiteManagement: false,
                actionWebsiteManagementMessage: "",
                clearSearchBox: !this.state.clearSearchBox,
                selectedAction: ""
            }, () => {
                this.getWebsiteManagementData()
                this.selectFilters("", CONSTANT_TYPE.allowedActions)
            })
        }
    }
    AddWebsiteManagementActionHandler = (ItemData) => {
        this.setState({
            loadingAction: true,
            actionWebsiteManagementMessage: ""
        }, () => {
            let requestBody = ItemData
            sendWebsiteManagementItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showAddWebsiteManagementItem: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Website added successfully."
                    }, this.getWebsiteManagementData)
                    console.log(res)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionWebsiteManagement: true,
                        actionWebsiteManagementMessage: errMessage
                    })
                })
        })
    }

    AddWebsiteManagementAction = () => {
        if (this.addWebsiteManagementModalRef.current) {
            this.addWebsiteManagementModalRef.current?.handleCategoryChange(1);
        }
        this.setState({
            showAddWebsiteManagementItem: true,
        });
    }

    CloseWebsiteManagementAction = () => {
        this.setState({
            showAddWebsiteManagementItem: false,
        })
    }

    CloseGlobalSettingsResponseModal = () => {
        this.setState({
            showGlobalSettingsResponseModal: false,
        })
    }

    UpdateWebsiteManagementActionHandler = (ItemData) => {
        this.setState({
            loadingAction: true,
            actionWebsiteManagementMessage: ""
        }, () => {
            let requestBody = ItemData
            updateWebsiteManagementItem(requestBody, this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"), this.props.location.search)
                .then((res) => {
                    this.setState({
                        loadingAction: false,
                        showUpdateWebsiteManagementItemModal: false,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Website updated successfully."
                    }, this.getWebsiteManagementData)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionWebsiteManagement: true,
                        actionWebsiteManagementMessage: errMessage
                    })
                })
        })
    }

    UpdateWebsiteManagementAction = () => {
        if (this.updateWebsiteManagementModalRef.current) {
            this.updateWebsiteManagementModalRef.current.resetModal();
        }
        this.setState({
            showUpdateWebsiteManagementItemModal: true,
        })
    }

    CloseUpdateWebsiteManagementAction = () => {
        this.setState({
            showUpdateWebsiteManagementItemModal: false,
        })
    }
    CloseGlobalSettingsResponseModal = () => {
        this.setState({
            showGlobalSettingsResponseModal: false,
        })
    }

    ShowDeleteConfirmationModal = () => {
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: true,
            DeleteConfirmationModalMessage: `Are you sure you want to delete <strong>${this.state.pageWiseSelectedRows[0].selectedRow.length}</strong> selected website(s)?<small class="form-text text-muted pt-3"><strong>Note: </strong>Delete action may take some time to reflect in our systems.</small>`
        })
    }

    DeleteWebsiteManagementHandler = () => {
        let selectedItemsBody = []
        this.state.pageWiseSelectedRows.forEach((eachPage) => {
            eachPage.selectedRow.forEach((eachRow) => {
                selectedItemsBody.push({ "itemId": eachRow.id, "url": eachRow.url, "tenantId": eachRow.tenant.id, "dataRegion": eachRow.tenant.dataRegion })
            })
        })
        let requestBody = {
            "items": selectedItemsBody,
        }
        this.setState({
            loadingAction: false,
            showDeleteConfirmationModal: false,
            //DeleteConfirmationModalMessage: `Are you sure you want to delete <strong>${this.state.pageWiseSelectedRows[0].selectedRow.length}</strong> selected endpoint(s)?<small class="form-text text-muted pt-3"><strong>Note: </strong>Delete action may take some time to reflect in our systems.</small>`
        }, () => {
            sendRequestWebsiteManagementDelete(
                this.props.referrerHostname + "_" + localStorage.getItem(this.props.referrerHostname + "_kaseya_tenant_id"),
                requestBody,
                this.props.location.search
            )
                .then(res => {
                    this.setState({
                        loadingAction: false,
                        clearSelection: !this.state.clearSelection,
                        showGlobalSettingsResponseModal: true,
                        messageGlobalSettingsResponseModal: "Deletion request received successfully."
                    })
                    setTimeout(() => {
                        this.getWebsiteManagementData()
                    }, 1000)
                })
                .catch((err) => {
                    let errMessage = ""
                    if (err.response) {
                        if (err.response.data.message !== undefined)
                            errMessage = err.response.data.message
                        else
                            errMessage = "Something went wrong; Please try again later."
                    }
                    else {
                        errMessage = "Something went wrong; Please try again later."
                    }
                    this.setState({
                        loadingAction: false,
                        showErrorActionWebsiteManagement: true,
                        actionWebsiteManagementMessage: errMessage,
                    })
                })
        })
    }

    CloseDeleteConfirmationModal = () => {
        this.setState({
            showDeleteConfirmationModal: false
        })
    }

    render() {
        let tenantCheck=this.state.filtered.find((arrayValue)=>this.findFilterValueByType(arrayValue,CONSTANT_TYPE.selectedTenant))
        let checkTenantDetails;
        if(tenantCheck)
            checkTenantDetails=this.props.tenants.tenant_list.find((tenantValue)=>tenantValue.id===tenantCheck.value)

        const tenantsWithDataRegionNull = [];
        let clearTenantSelect = false;
        this.props.tenants.tenant_list.forEach((tenant) => {
            if (
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.dataRegion) ||
                NULL_UNDEFINED_EMPTY_CHECK.includes(tenant.apiHost)
              ) {
                tenantsWithDataRegionNull.push(tenant.id);
              }
        });
        let selectedTenantId = this.state.filtered.find(
            (arrayValue) => arrayValue.type === CONSTANT_TYPE.selectedTenant
        );
        if (
            selectedTenantId &&
            tenantsWithDataRegionNull.length &&
            tenantsWithDataRegionNull.filter(
                (item) => item === selectedTenantId.value
            ).length
        ) {
            clearTenantSelect = true;
        }

        let messageForForceSync = this.props.settings?.SophosIdTypeIsTenant ? this.props.website_management && this.props.website_management.last_updated_times && this.props.website_management.last_updated_times[this.props.settings?.SophosTenantId] ? 'Last Force Sync Time: ' + moment.unix(this.props.website_management.last_updated_times[this.props.settings?.SophosTenantId]).format('YYYY-MM-DD HH:mm:ss') : '' : selectedTenantId && selectedTenantId.value && this.props.website_management.last_updated_times && this.props.website_management.last_updated_times[selectedTenantId.value] ? 'Last Force Sync Time: ' + moment.unix(this.props.website_management.last_updated_times[selectedTenantId.value]).format('YYYY-MM-DD HH:mm:ss') : ''

        return (
            <CommonLayout title="Website Management" displayTitle={true}>
                <ErrorModal
                    show={this.props.tenants.error_response_message !== null || this.props.website_management.error_response_message !== null}
                    closeModal={() => {
                        this.props.tenants.error_response_message !== null ?
                            this.clearTenantErrorResponseToast()
                            :
                            this.clearErrorResponseToast()
                    }}
                    modalMessage={
                        this.props.tenants.error_response_message !== null && this.props.website_management.error_response_message === null ?
                            this.props.tenants.error_response_message
                            :
                            this.props.website_management.error_response_message}
                />
                <ErrorModal
                    show={this.state.showErrorActionWebsiteManagement}
                    closeModal={this.closeActionWebsiteManagement}
                    modalMessage={this.state.actionWebsiteManagementMessage}
                />
                <ActionLoadingModal show={this.state.loadingAction} />
                <ConfirmationModal
                    show={this.state.showDeleteConfirmationModal}
                    confirmAction={() => this.DeleteWebsiteManagementHandler()}
                    closeModal={this.CloseDeleteConfirmationModal}
                    modalMessage={this.state.DeleteConfirmationModalMessage}
                />
                <AddWebsiteManagementItemModal
                    {...this.props}
                    show={this.state.showAddWebsiteManagementItem}
                    closeModal={this.CloseWebsiteManagementAction}
                    confirmModal={this.AddWebsiteManagementActionHandler}
                    ref={this.addWebsiteManagementModalRef}
                />
                <UpdateWebsiteManagementItemModal
                    {...this.props}
                    show={this.state.showUpdateWebsiteManagementItemModal}
                    update_data={this.state.selectedWebsiteManagementBody}
                    closeModal={this.CloseUpdateWebsiteManagementAction}
                    confirmModal={this.UpdateWebsiteManagementActionHandler}
                    ref={this.updateWebsiteManagementModalRef}
                />
                <GlobalSettingsResponseModal
                    {...this.props}
                    show={this.state.showGlobalSettingsResponseModal}
                    closeModal={this.CloseGlobalSettingsResponseModal}
                    message={this.state.messageGlobalSettingsResponseModal}
                />
                <ToastContainer
                    position="top-right"
                    autoClose={7000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable={false}
                    pauseOnHover={false}
                    enableMultiContainer 
                    containerId={'A'}
                />
                <div className="row mt-2 mx-1">
                    <div className="col-4">
                        <div className="input-group-append row">
                            
                            {!this.props.settings.SophosIdTypeIsTenant && 
                                <div className="col px-0 mx-1 text-left">
                                    <div className="col-sm-12 px-0 mx-1 text-left">
                                        <span>Tenants</span>
                                        <MultiSelectTextbox
                                            options={this.state.tenantList.sort(sortingData)}
                                            isMulti={false}
                                            filteredSelectedValue={
                                                this.state.filtered.find((arrayValue) =>
                                                    this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)) ?
                                                    this.state.tenantList.filter((element) => element.value === this.state.filtered.find((arrayValue) =>
                                                        this.findFilterValueByType(arrayValue, CONSTANT_TYPE.selectedTenant)).value)
                                                    : []
                                            }
                                            onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.selectedTenant)}
                                            clearValue={this.state.clearFilterBool}
                                            clearable={true}
                                            isLoading={this.props.tenants.is_loading}
                                            disabledSelect={this.props.website_management.is_loading}
                                        />
                                    </div>
                                </div>
                            }
                            <div className="col px-0 mx-1 text-left">
                                <span>Category Override</span>
                                <MultiSelectTextbox
                                    options={WEBSITE_CATEGORY_OPTIONS}
                                    isMulti={false}
                                    filteredSelectedValue={
                                        this.state.filtered.find((arrayValue) =>
                                            this.findFilterValueByType(arrayValue, CONSTANT_TYPE.categoryName))
                                    }
                                    onSelectOption={(value) => this.selectFilters(value, CONSTANT_TYPE.categoryName)}
                                    clearable={true}
                                    clearValue={this.state.clearFilterBool}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-3 text-left mt-3">
                        <button type="button" className="btn btn-secondary btn-sm ml-2" disabled={this.props.website_management.is_loading} onClick={this.clearFilter.bind(this)}>Clear</button>
                    </div>
                    <div className="col-5 justify-content-end flex pt-3 pr-0" style={{ display: "flex" }}>

                        <button style={{ maxHeight: "29px" }} type="button" className="btn btn-primary btn-sm mr-2 " onClick={this.AddWebsiteManagementAction}>
                            Add
                        </button>
                        <button style={{ maxHeight: "29px" }} disabled={!(this.state.selectedWebsiteManagementBody && this.state.selectedWebsiteManagementBody.length === 1)} type="button" className="btn btn-primary btn-sm mr-2" onClick={this.UpdateWebsiteManagementAction}>
                            Update
                        </button>
                        <button style={{ maxHeight: "29px" }} disabled={!(this.state.selectedWebsiteManagementBody && this.state.selectedWebsiteManagementBody.length > 0)} type="button" className="btn btn-primary btn-sm mr-2" onClick={this.ShowDeleteConfirmationModal}>
                            Delete
                        </button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-outline-primary btn-sm" disabled={((tenantCheck===undefined || checkTenantDetails===undefined) && !this.props.settings.SophosIdTypeIsTenant) || clearTenantSelect} onClick={this.getWebsiteManagementData.bind(this,false,false,true)}><i className="fa fa-refresh"/> Force Sync</button>
                        <button type="button" style={{ maxHeight: "29px" }} className="btn btn-primary round-help-btn ml-2 btn-sm" data-tip={this.props.website_management.req_per_hour!==null?`Maximum of ${this.props.website_management.req_per_hour}x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}`: `Maximum of 4x per hour allowed. ${!this.props.settings.SophosIdTypeIsTenant ? "Select a tenant to enable Force Sync." : ""}`} data-for='helpTime'><i className="fa fa-question"/></button>
                        <ReactTooltip id="helpTime" effect="solid" type="info" place="left"/>
                    </div>
                </div>
                <div className="row mt-2 mx-1">
                    <div className="col-12 text-right">
                        <b>{messageForForceSync}</b>
                    </div>
                </div>
                <div className="row m-1 card-content-height">
                    <div className="col-md-12 pr-1">
                        <TableGrid
                            clearValue={this.state.clearFilterBool}
                            defaultSortedCol={this.state.defaultSorted}
                            columnStructure={this.state.columnDefs}
                            responseData={this.filterData(this.state.rowData)}
                            loading={this.props.website_management.is_loading}
                            stateObject={this.props.website_management}
                            pageSize={this.filterData(this.state.rowData).length < this.props.website_management.page_size ? this.filterData(this.state.rowData).length : this.props.website_management.page_size}
                            filtered={this.state.filtered}
                            noDataText={this.tablegridMessage()}
                            keyField="_id"
                            moduleName="websiteManagement"
                            clearSearchBox={this.state.clearSearchBox}
                            note="Websites will be displayed in some time if you have configured settings recently."
                            singleSelectedRow={(selectedId) => this.getWebsiteManagementSelectedId(selectedId)}
                            pageWiseSelectedRowsFromTable={(currentPage, selectedRowData) => this.getPageWiseSelectedRowsFromTable(currentPage, selectedRowData)}
                            onPageChangeEvent={(page) => this.setTablePage(page)}
                            nonSelectableRows={this.getNonSelectableRows(this.filterData(this.state.rowData))}
                            onSortChange={this.state.sortChangeBool}
                            onPerformAction={this.state.clearSelection}
                        />
                    </div>
                </div>
            </CommonLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteManagementItems)